import { BaseLogger, LogLevel } from '@shared/services/logger';
import { logs } from '@opentelemetry/api-logs';

// Initialize the global Otel logger for the Shared Logger to pick up
const otelLogger = logs.getLogger('constantina-uix');
(globalThis as any)._OTEL_LOGGER = otelLogger;

class AdvancedLogger extends BaseLogger {
    constructor() {
        super('ConstantinaWeb');
    }
    // Shared BaseLogger now handles console, OCI export, and _OTEL_LOGGER emission
}

export { LogLevel };
export const Logger = new AdvancedLogger();
